(function goodDeedsReturnVisits() {
  'use strict';

  var drawer = document.getElementById('GoodDeedsReturnDrawer');

  if (!drawer) return;

  var panel = drawer.querySelector('.gd-return-drawer__panel');
  var favoritesList = drawer.querySelector('[data-gd-favorites-list]');
  var recentList = drawer.querySelector('[data-gd-recent-list]');
  var favoritesEmpty = drawer.querySelector('[data-gd-favorites-empty]');
  var recentEmpty = drawer.querySelector('[data-gd-recent-empty]');
  var favoritesKey = 'good-deeds-favorites-v1';
  var recentlyViewedKey = 'good-deeds-recently-viewed-v1';
  var favorites = load(favoritesKey);
  var recentlyViewed = load(recentlyViewedKey);
  var previouslyFocused;

  function load(key) {
    try {
      var saved = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function persist(key, items) {
    try {
      window.localStorage.setItem(key, JSON.stringify(items));
    } catch (error) {
      // Favorites remain useful during this visit even when storage is disabled.
    }
  }

  function productFrom(element, current) {
    var prefix = current ? 'currentProduct' : 'product';
    return {
      id: element.dataset[prefix + 'Id'],
      title: element.dataset[prefix + 'Title'],
      url: element.dataset[prefix + 'Url'],
      price: element.dataset[prefix + 'Price'] || '',
      image: element.dataset[prefix + 'Image'] || '',
      currency: current ? drawer.dataset.currency : element.dataset.productCurrency
    };
  }

  function renderList(container, empty, items) {
    container.replaceChildren();
    empty.hidden = items.length > 0;

    items.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'gd-return-item';
      link.href = item.url;

      if (item.image) {
        var picture = document.createElement('img');
        picture.src = item.image;
        picture.alt = '';
        picture.loading = 'lazy';
        link.appendChild(picture);
      }

      var copy = document.createElement('span');
      var title = document.createElement('strong');
      title.textContent = item.title;
      copy.appendChild(title);

      if (item.price && item.currency === drawer.dataset.currency) {
        var price = document.createElement('small');
        price.textContent = item.price;
        copy.appendChild(price);
      }

      link.appendChild(copy);
      container.appendChild(link);
    });
  }

  function refresh() {
    renderList(favoritesList, favoritesEmpty, favorites);
    renderList(recentList, recentEmpty, recentlyViewed);

    document.querySelectorAll('[data-gd-saved-count]').forEach(function (counter) {
      counter.textContent = String(favorites.length);
      counter.hidden = favorites.length === 0;
    });

    document.querySelectorAll('[data-gd-save-product]').forEach(function (button) {
      var saved = favorites.some(function (item) {
        return item.id === button.dataset.productId;
      });
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-saved', saved);
    });
  }

  function rememberCurrentProduct() {
    if (!drawer.dataset.currentProductId) return;

    var current = productFrom(drawer, true);
    recentlyViewed = recentlyViewed.filter(function (item) {
      return item.id !== current.id;
    });
    recentlyViewed.unshift(current);
    recentlyViewed = recentlyViewed.slice(0, 8);
    persist(recentlyViewedKey, recentlyViewed);
  }

  function toggleFavorite(button) {
    var product = productFrom(button, false);
    if (!product.id || !product.url) return;

    var alreadySaved = favorites.some(function (item) {
      return item.id === product.id;
    });

    if (alreadySaved) {
      favorites = favorites.filter(function (item) {
        return item.id !== product.id;
      });
    } else {
      favorites.unshift(product);
      favorites = favorites.slice(0, 30);
    }

    persist(favoritesKey, favorites);
    refresh();

    try {
      drawer.dispatchEvent(
        new CustomEvent('good-deeds:favorites-updated', {
          bubbles: true,
          detail: { productId: product.id, saved: !alreadySaved, total: favorites.length }
        })
      );
    } catch (error) {
      // Optional external integrations never block normal storefront behavior.
    }
  }

  function open() {
    previouslyFocused = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gd-return-drawer-open');
    panel.focus();
  }

  function close() {
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gd-return-drawer-open');

    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-gd-save-product], [data-gd-open-saved], [data-gd-close-saved]');
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    if (target.hasAttribute('data-gd-save-product')) {
      toggleFavorite(target);
    } else if (target.hasAttribute('data-gd-open-saved')) {
      open();
    } else {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  document.addEventListener('shopify:section:load', refresh);
  rememberCurrentProduct();
  refresh();
})();
